import { Component, HostListener, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@bbj/components';
import environment from "src/environments/environment";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export default class AppComponent implements OnInit {
  activateRoute = inject(ActivatedRoute);
  authService = inject(AuthService);
  route = inject(Router);

  title = 'BBJPORTAL';

  projects;

  mainheight: number;

  isdisabledBtn = true;

  isIframe = false;

  @HostListener('window:resize')
  onResize(): void {
    this.mainheight = window.innerHeight;
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.authService.initService(environment.stage, environment.azureNew.tenantId);
    this.mainheight = window.innerHeight;
  }
}
